import React, { Fragment, useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Label } from '@lux/components';
import { noop } from '@lux/helpers';

import { BodyPrimary, BodySecondary } from '../Base';
import Checkbox from '../Checkbox';

import slugify from '../../helpers/slugify';

import IconChevronDown from '../../assets/svgs/chevron-down.svg';
import IconChevronUp from '../../assets/svgs/chevron-up.svg';
import isSimOnlyPlan from '../../helpers/is-sim-only-plan';

const StyledLabel = styled(Label)`
  display: inline-block;
  color: ${p =>
    p.disabled ? p.theme.colours.grey_500 : p.theme.colours.nearBlack};
  user-select: none;
  cursor: ${p => (p.disabled ? 'default' : 'pointer')};
  margin: 0;
`;

const StyledBodySecondary = styled(BodySecondary)`
  display: inline-block;
  margin-left: ${p => p.theme.spacing(2)};
`;

const StyledTitle = styled.div`
  display: flex;
  align-items: center;
  vertical-align: middle;
  margin: ${p => p.theme.spacing(3)} 0;
  color: ${p => p.theme.colours.grey_900};
  cursor: pointer;
`;

const StyledBodyPrimary = styled(BodyPrimary)`
  margin-right: ${({ theme }) => theme.spacing(1)};
`;

const StyledContent = styled.div`
  margin-bottom: ${p => p.theme.spacing(3)};
`;

const StyledCheckboxItem = styled.div`
  margin-bottom: ${p => p.theme.spacing(2)};
  display: flex;
  flex-direction: row;

  &:last-child {
    margin-bottom: 0;
  }
`;

const PhoneCatalogFilter = props => {
  const { items, onChange, title, active, checkedItems } = props;
  const [showContent, setShowContent] = useState(active);
  const handleChange = item => {
    const newCheckedItems = {
      ...checkedItems,
      [item]: !checkedItems[item]
    };
    onChange(newCheckedItems);
  };

  return (
    <Fragment>
      <StyledTitle onClick={() => setShowContent(!showContent)}>
        <StyledBodyPrimary>{title}</StyledBodyPrimary>
        {showContent ? (
          <IconChevronUp size={8} />
        ) : (
          <IconChevronDown size={8} />
        )}
      </StyledTitle>
      {showContent && (
        <StyledContent data-testid="content">
          {items.map((item, key) => {
            const id = slugify(`${title}-${item.text}`);
            const isDisabled = Boolean(
              !checkedItems[item.value] && item.disabled
            );

            return (
              <StyledCheckboxItem key={key}>
                <Checkbox
                  id={id}
                  checked={checkedItems[item.value]}
                  onChange={() => handleChange(item.value)}
                  value={item.value}
                  data-testid={id}
                  disabled={isDisabled}
                />
                <StyledLabel
                  htmlFor={id}
                  disabled={isDisabled}
                  data-testid="label-text"
                >
                  <StyledBodySecondary>{item.text}</StyledBodySecondary>
                </StyledLabel>
              </StyledCheckboxItem>
            );
          })}
        </StyledContent>
      )}
    </Fragment>
  );
};

PhoneCatalogFilter.defaultProps = {
  onChange: noop
};

PhoneCatalogFilter.propTypes = {
  /** Sets default active state */
  active: PropTypes.bool,
  /** Set of checked items and their checked state */
  checkedItems: PropTypes.object,
  /** Sets the list of brands */
  items: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string,
      value: PropTypes.string
    })
  ),
  /** Sets the change event */
  onChange: PropTypes.func,
  /** Sets the title of the components */
  title: PropTypes.string
};

export default PhoneCatalogFilter;
